import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";

import "./App.css";

import NotFound from "./pages/NotFound/NotFound";
import DefaultLayout from "./layout/DefaultLayout";
import SessionSharing from "./pages/SessionSharing/SessionSharing";
Amplify.configure(awsExports);
// Amplify.Logger.LOG_LEVEL = "DEBUG";

const App: React.FC = () => {
  console.log("Full Swing Kit Web.  Version 1.1.4")
  return (
    <Router>
      <Routes>
        <Route element={<DefaultLayout />}>
          <Route path="/lm/share/:shareUrl" element={<SessionSharing />} />
          <Route path="not-found" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
};
export default App;
